<div class="checklist-dialog-container">
	<mat-form-field appearance="outline" class="checklist-input">
		<mat-label>{{ 'checklist_items_to_add' | translate }}</mat-label>
		<input
			matInput
			[formControl]="itemsToAddControl"
			type="number"
			min="1"
			(blur)="addChecklistItemsToList()"
			(keydown.enter)="addChecklistItemsToList()"
		/>
	</mat-form-field>

	<form [formGroup]="checklistForm">
		<div formArrayName="items" class="checklist-dialog-content">
			<div class="checklist-item-list nice-scroll colored-scroll-track visible-scroll">
				@for (control of itemsArray().controls; track control; let i = $index) {
					<mat-label>{{ 'checklist_item' | translate }} {{ i + 1 }} </mat-label>

					<mat-form-field appearance="outline" class="checklist-input">
						<input
							matInput
							[placeholder]="'checklist_item' | translate"
							[formControlName]="i"
						/>
					</mat-form-field>
				}
			</div>
		</div>
	</form>

	<div class="checklist-dialog-actions">
		<button
			mat-stroked-button
			class="add-checklist-item-button"
			[mat-dialog-close]="null"
		>
			{{ 'cancel' | translate }}
		</button>
		<button
			mat-raised-button
			class="add-checklist-item-button"
			[mat-dialog-close]="itemsArray().value"
		>
			{{ 'save' | translate }}
		</button>
	</div>
</div>
